module.exports = __webpack_public_path__ + "img/horizontal_4_3_7042.8391ef28.png";